import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { CustomMessages, EasyDialog } from '@shared';
import { MatAccordion } from '@angular/material/expansion';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { MatCheckbox, MatDialog, MatExpansionPanelHeader } from '@angular/material';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  FormArray,
  ValidatorFn,
  AbstractControlOptions,
  AsyncValidatorFn,
} from '@angular/forms';
import { environment } from '@env/environment';
import { AuditSummaryOutputDto } from 'app/model/audit-summary-output-dto';
//import { AuditorBenchworkflowComponent } from './auditor-benchworkflow/auditor-benchworkflow.component';
import { AuditorBenchAuditDetailResponseDTO } from 'app/model/auditor-bench-audit-detail-response-dto';
import { AuditorBenchAuditDetailDTO } from 'app/model/auditor-bench-audit-detail-dto';
import { AuditProgramDepartmentSectionBean } from 'app/model/audit-program-department-section';
import { SupportingDocumentDTO } from 'app/model/supporting-document-dto';
import { AuditProgramDto } from 'app/model/audit-program-dto';
import { AuditDetailCheckboxCount } from 'app/model/auditor-bench-audit-detail-response-dto';
import { AuditorBenchAuditDetailScopeDTO } from 'app/model/auditor-bench-audit-detail-scope-dto';
import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { AuditDetailsService } from 'app/service/audit-details.service';
import { ComboPopulation } from 'app/model/combo-population';
import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { RatingMstDTO } from 'app/model/rating-mst-dto';
import { AuditProgramResponse } from 'app/model/audit-program-response-dto';
import { ButtonRoleMapResponse } from 'app/model/button-role-map-response-bean';
import { UserSiteMapNAccessDTO } from 'app/model/user-site-map-n-access-dto';
import { UmbrellaGroupDTO } from 'app/model/umbrella-group-dto';
import { DownloadReportService } from 'app/service/download-reports-service';
import { AdmRatingMst } from 'app/model/adm-rating-mst.enum';
import { DatePipe } from '@angular/common';
import { AdmCodesDetails } from 'app/model/adm-codes-details.enum';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { SupportingDocumentService } from 'app/service/supporting-doc-service';
import { SupportingDocumentBean } from 'app/model/supporting-document-bean';
//29-09-2021
import { AuditeeDetailsService } from 'app/service/auditee-details.service';
import * as moment from 'moment';
import { MatExpansionPanel } from '@angular/material';

type ValueEqualsFn = (orig: any, curr: any) => boolean;

interface ValueDirtyAbstractControlOptions extends AbstractControlOptions {
  equals?: ValueEqualsFn;
}

class ValueDirtyFormControl extends FormControl {
  private _origFormState: any;
  private _equals: ValueEqualsFn = (orig, curr) => `${orig}` === `${curr}`;

  constructor(
    formState: any = null,
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | ValueDirtyAbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ) {
    super(formState, validatorOrOpts, asyncValidator);
    this._equals =
      (validatorOrOpts && (validatorOrOpts as ValueDirtyAbstractControlOptions).equals) ||
      this._equals;
    this._origFormState = formState;
    this.valueChanges.subscribe(value => {
      if (this._equals(this._origFormState, value)) {
        this.markAsPristine();
      }
    });
  }

  reset(formState: any = null, options: { onlySelf?: boolean; emitEvent?: boolean } = {}) {
    super.reset(formState, options);
    this._origFormState = formState;
  }
}

@Component({
  selector: 'app-documentrepo',
  templateUrl: './documentrepo.component.html',
  styleUrls: ['./documentrepo.component.scss'],
  providers: [TranslatePipe],
})
export class DocumentrepoComponent implements OnInit {
  //showScopeAllOption: boolean = true;
  isScopeAllChecked: boolean = false;
  openedauditlog = false;
  //list1: any;
  public allSelected: boolean = false;
  //public CodesDetailsEnum = AdmCodesDetails;
  parsedJson: any;
  auditDetailForm: FormGroup;
  dataForm: FormGroup;
  detailList: FormArray;
  openedpending = false;
  openedcomments = false;
  showPostComment = false;
  openedattachments = false;
  openeddept = false;
  isShow: boolean = true;
  openeddepartment = false;
  enableShowAllRecords: string;
  enableAllTransaction: string;
  allDownload: string;
  enableShowAllRecordsDepartmentWise: string;
  enableAllTransactionDepartmentWise: string;
  userSiteMapNAccessDTO: UserSiteMapNAccessDTO = new UserSiteMapNAccessDTO();
  umbrellaGroupList: UmbrellaGroupDTO[] = [];
  auditorBenchAuditDetailDTO: AuditorBenchAuditDetailDTO = new AuditorBenchAuditDetailDTO();
  auditorBenchAuditDetailResponseDTO: AuditorBenchAuditDetailResponseDTO = new AuditorBenchAuditDetailResponseDTO();
  auditDetailCheckboxCount: AuditDetailCheckboxCount = new AuditDetailCheckboxCount();
  auditProgramDepartmentSectionList: AuditProgramDepartmentSectionBean[] = [];
  auditorBenchAuditDetailScopeList: AuditorBenchAuditDetailScopeDTO[] = [];
  auditorBenchAuditDetailScopeDetailList: AuditorBenchAuditDetailScopeDetailDTO[];
  auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO = new AuditorBenchAuditDetailScopeDetailDTO();
  auditorBenchAuditDetailScopeDetailActionDTO: AuditorBenchAuditDetailScopeDetailDTO = new AuditorBenchAuditDetailScopeDetailDTO();
  selectedDepartmentId: string = '0';
  selectedSectionId: string = '';
  selectedDepartementName: string = '';
  selectedSectionName: string = '';
  commonDTO: CommonDTO = new CommonDTO();
  reasonDropdownList: ComboPopulation[] = [];
  ratingDropdownList: RatingMstDTO[] = [];
  pdcaDropdownList: ComboPopulation[] = [];
  pdcaDropdownListCopy: ComboPopulation[] = [];
  items: ComboPopulation[] = [];
  allExpandState = false;
  auditProgramId: string;
  scopeId: string;
  expandCount: number = 0;
  clickedAction: string = '';
  selectedScopeIndex: number = 0;
  selectedScopeId: string = '0';
  captureImpactAnalysis: boolean = false;
  enableNcWorkflowForAuditors: boolean = false;
  enableDraftReleaseWorkflow: boolean = false;
  enableAddJoinderRemarks: boolean = false;
  enableAddRcoTeamComments: boolean = false;
  allowNcModificationBeforeDraftReportRelease: boolean = false;
  allowNcReturnBeforeDraftReportRelease: boolean = false;
  isWorkflowRequired: boolean = false;
  isWorkflowRequiredStr: string = '0';
  cdAuditStatus: string = '';
  isNcFinalized: boolean = false;
  isFinalReportReleased: boolean = false;
  isMcReleased: boolean = false;
  cdAuditeeStage: string = '';
  isDraftReportReleased: boolean = false;
  cdAuditStage: string = '';

  selectedIndex: any;
  @Input() auditProgramMstObj: AuditProgramDto;
  @Input() auditSummaryOutputDto: AuditSummaryOutputDto;
  @ViewChildren('panelH') panelH: QueryList<MatExpansionPanelHeader>;
  @ViewChild('ch', { static: false }) ch: MatCheckbox;

  checkIncludeInReport: boolean;
  disabledIncludeInReport: boolean;
  openAddScopePage: boolean = false;
  openSubObservationPage: boolean = false;
  openSuppDocPage: boolean = false;
  openPendingItemPage: boolean = false;
  auditItemDetails: SupportingDocumentDTO = new SupportingDocumentDTO();
  auditProgramResponse = new AuditProgramResponse();
  buttonRoleMapResponse: ButtonRoleMapResponse[];
  buttonMap: string;
  isWfRequired: string;
  isPostCommented: string;
  isItemClosed: string;
  isNcFinalised: string;
  isDetailOpen: true;
  deleteScopeBtn: boolean = false;
  pendingItemsBtn: boolean = false;
  addScopeBtn: boolean = false;
  addSubScopeBtn: boolean = false;
  //attachmentBtn: boolean = false;
  saveBtn: boolean = false;
  submitBtn: boolean = false;
  returnBtn: boolean = false;
  approveBtn: boolean = false;
  downloadAllFilesBtn: boolean = false;
  exportToExcel: boolean = false;
  auditProgramLog: boolean = false;
  manageAuditorBtn: boolean = false;
  closeNonNc: boolean = false;
  postCommentBtn: boolean = false;
  ncFinalize: boolean = false;
  auditLogEnable: boolean = false;
  selectedCb: any = [];
  isDisplayDownloadButton: boolean = false;
  openAuditeeSide: boolean = false;
  openRcoRejoinderSide: boolean = false;
  openNcScopeSide: boolean = false;
  openPncScopeSide: boolean = false;
  openPdcaSide: boolean = false;
  openPncPdcaSide: boolean = false;
  openAuditorReturnBtnSide: boolean = false;
  openSaveSubmitBtnSide: boolean = false;
  draftAtAuditeeSideNote: boolean = false;
  draftAtAuditeeSidePncNote: boolean = false;

  // Fields added on 24-09-2021
  @Input() documentRepositoryType: string;
  supportingDocumentDto: SupportingDocumentDTO = new SupportingDocumentDTO();
  supportingDocumentList: SupportingDocumentBean[] = [];
  deleteItem: SupportingDocumentBean;
  supportingDocumentValue: SupportingDocumentBean = new SupportingDocumentBean();
  attachmentBtn: boolean = true;
  step: string;
  isTable: string = 'true';
  isDocOvservation: boolean = false;
  tinymceConfig: any = environment.TINYMCE_CONFIG;
  tiny: any = environment.TINYMCE_CONFIG_FOR_MAJOR_ESC;
  tinymceAPIKey: any = environment.TINYMCE_API_KEY;
  readOnly: boolean = true;
  isDocumentRepository: boolean = true;
  attachmentNameSearch: string;
  supportingDocIndex: string;
  //End

  constructor(
    private modeldialog: MatDialog,
    private customMessage: CustomMessages,
    private sidebarComponent: SidebarComponent,
    public dialog: EasyDialog,
    private ts: TranslatePipe,
    private commonService: CommonService,
    private auditDetailsService: AuditDetailsService,
    private fb: FormBuilder,
    private downloadReportService: DownloadReportService,
    private datePipe: DatePipe,
    private suppDocService: SupportingDocumentService,
    private auditeeDetailsService: AuditeeDetailsService
  ) { }

  ngOnInit() {
    this.dataForm = new FormGroup({
      detailList: new FormArray([]),
    });
    this.commonDTO.departmentId = '0';
    this.commonDTO.sectionId = '0';
    this.commonDTO.searchValue = null;
    this.getAuditProgramScopeAttachmentData();

    //For Auditee
    if (this.auditSummaryOutputDto.callingType == 'AS') {
      this.auditorBenchAuditDetailDTO.isPnc = '0';
      this.commonDTO.isPnc = '0';
    } else if (this.auditSummaryOutputDto.callingType == 'PNC') {
      this.auditorBenchAuditDetailDTO.isPnc = '1';
      this.commonDTO.isPnc = '1';
      if (this.auditSummaryOutputDto.actionType == 'PENDING') {
        this.commonDTO.isPnc = '1';
      }
    }
    //End

    // this.auditorBenchAuditDetailDTO.scopePrivilege = 'Auditor';
    if (this.auditProgramMstObj.auditProgramId == undefined) {
      this.getAuditProgramDetailByAuditId();
    } else {
      this.commonDTO.siteId = this.auditProgramMstObj.siteId;
      this.auditProgramId = this.auditProgramMstObj.auditProgramId;

      if (this.auditProgramMstObj.isWorkflowRequired == '1') {
        this.isWorkflowRequired = true;
      }

      if (this.auditProgramMstObj.isDraftReportReleased == '1') {
        this.isDraftReportReleased = true;
      }

      if (this.auditProgramMstObj.isNcFinalized == '1') {
        this.isNcFinalized = true;
      }

      if (this.auditProgramMstObj.isFinalReportReleased == '1') {
        this.isFinalReportReleased = true;
      }

      if (this.auditProgramMstObj.isMcReleased == '1') {
        this.isMcReleased = true;
      }

      this.cdAuditStatus = this.auditProgramMstObj.cdAuditStatus;
      this.cdAuditStage = this.auditProgramMstObj.cdAuditStage;
      this.cdAuditeeStage = this.auditProgramMstObj.cdAuditeeStage;
    }

    if (this.auditSummaryOutputDto.auditId != undefined) {
      this.auditorBenchAuditDetailDTO.auditProgramId = this.auditSummaryOutputDto.auditId;
      this.auditorBenchAuditDetailDTO.auditProgramStatus = this.auditSummaryOutputDto.auditStatusId;
      this.auditorBenchAuditDetailDTO.auditProgramStage = this.auditSummaryOutputDto.auditStageId;
      this.auditSummaryOutputDto.callingType = this.auditSummaryOutputDto.callingType.toUpperCase();
      this.auditSummaryOutputDto.actionType = this.auditSummaryOutputDto.actionType.toUpperCase();
      this.auditProgramId = this.auditSummaryOutputDto.auditId;

      if (this.auditSummaryOutputDto.callingType == 'AS') {
        if (this.auditSummaryOutputDto.actionType == 'PENDING') {
          this.auditorBenchAuditDetailDTO.pendingSelected = true;

          this.auditorBenchAuditDetailDTO.pending = '1';
          this.commonDTO.pending = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'NCINWORKFLOW') {
          this.auditorBenchAuditDetailDTO.inWfSelected = true;

          this.auditorBenchAuditDetailDTO.inWf = '1';
          this.commonDTO.inWf = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'NCCONFIRMED') {
          this.auditorBenchAuditDetailDTO.ncSelected = true;

          this.auditorBenchAuditDetailDTO.nc = '1';
          this.commonDTO.nc = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'CLOSED') {
          this.auditorBenchAuditDetailDTO.closedSelected = true;

          this.auditorBenchAuditDetailDTO.closed = '1';
          this.commonDTO.closed = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'NOTAPPLICABLE') {
          this.auditorBenchAuditDetailDTO.naSelected = true;

          this.auditorBenchAuditDetailDTO.na = '1';
          this.commonDTO.na = '1';
        }
      } else if (this.auditSummaryOutputDto.callingType == 'NC') {
        this.auditorBenchAuditDetailDTO.ncSelected = true;

        this.auditorBenchAuditDetailDTO.nc = '1';
        this.commonDTO.nc = '1';
        if (this.auditSummaryOutputDto.actionType == 'TOTALNC') {
        } else if (this.auditSummaryOutputDto.actionType == 'OPEN') {
          this.auditorBenchAuditDetailDTO.returnSelected = true;
          this.auditorBenchAuditDetailDTO.notStartedSelected = true;
          this.auditorBenchAuditDetailDTO.planSelected = true;
          this.auditorBenchAuditDetailDTO.doSelected = true;
          this.auditorBenchAuditDetailDTO.checkSelected = true;

          this.auditorBenchAuditDetailDTO.returned = '1';
          this.auditorBenchAuditDetailDTO.notStarted = '1';
          this.auditorBenchAuditDetailDTO.plan = '1';
          this.auditorBenchAuditDetailDTO.doing = '1';
          this.auditorBenchAuditDetailDTO.check = '1';
          this.commonDTO.returned = '1';
          this.commonDTO.notStarted = '1';
          this.commonDTO.plan = '1';
          this.commonDTO.doing = '1';
          this.commonDTO.check = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'CLOSEDNC') {
          this.auditorBenchAuditDetailDTO.actSelected = true;
          this.auditorBenchAuditDetailDTO.act = '1';
          this.commonDTO.act = '1';
        }
      } else if (this.auditSummaryOutputDto.callingType == 'PNC') {
        this.auditorBenchAuditDetailDTO.pncSelected = true;

        this.auditorBenchAuditDetailDTO.pnc = '1';
        this.commonDTO.pnc = '1';
        if (this.auditSummaryOutputDto.actionType == 'TOTALNC') {
        } else if (this.auditSummaryOutputDto.actionType == 'OPEN') {
          this.auditorBenchAuditDetailDTO.returnSelected = true;
          this.auditorBenchAuditDetailDTO.notStartedSelected = true;
          this.auditorBenchAuditDetailDTO.planSelected = true;
          this.auditorBenchAuditDetailDTO.doSelected = true;
          this.auditorBenchAuditDetailDTO.checkSelected = true;

          this.auditorBenchAuditDetailDTO.returned = '1';
          this.auditorBenchAuditDetailDTO.notStarted = '1';
          this.auditorBenchAuditDetailDTO.plan = '1';
          this.auditorBenchAuditDetailDTO.doing = '1';
          this.auditorBenchAuditDetailDTO.check = '1';
          this.commonDTO.returned = '1';
          this.commonDTO.notStarted = '1';
          this.commonDTO.plan = '1';
          this.commonDTO.doing = '1';
          this.commonDTO.check = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'CLOSEDNC') {
          this.auditorBenchAuditDetailDTO.actSelected = true;

          this.auditorBenchAuditDetailDTO.act = '1';
          this.commonDTO.act = '1';
        }
      } else if (this.auditSummaryOutputDto.callingType == 'RISK') {
        this.auditorBenchAuditDetailDTO.riskRating = '1';
        this.commonDTO.riskRating = '1';
        this.auditorBenchAuditDetailDTO.riskRatingId = this.auditSummaryOutputDto.actionType;
        this.auditorBenchAuditDetailDTO.riskRatingSelected = true;
      }

      // If click NC OR PNC and Return/Not Started/P D C A
      if (
        this.auditSummaryOutputDto.callingType == 'NC' ||
        this.auditSummaryOutputDto.callingType == 'PNC'
      ) {
        if (this.auditSummaryOutputDto.actionType == 'RETURN') {
          this.auditorBenchAuditDetailDTO.returnSelected = true;

          this.auditorBenchAuditDetailDTO.returned = '1';
          this.commonDTO.returned = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'NOTSTARTED') {
          this.auditorBenchAuditDetailDTO.notStartedSelected = true;

          this.auditorBenchAuditDetailDTO.notStarted = '1';
          this.commonDTO.notStarted = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'PLAN') {
          this.auditorBenchAuditDetailDTO.planSelected = true;

          this.auditorBenchAuditDetailDTO.plan = '1';
          this.commonDTO.plan = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'DO') {
          this.auditorBenchAuditDetailDTO.doSelected = true;

          this.auditorBenchAuditDetailDTO.doing = '1';
          this.commonDTO.doing = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'CHECK') {
          this.auditorBenchAuditDetailDTO.checkSelected = true;

          this.auditorBenchAuditDetailDTO.check = '1';
          this.commonDTO.check = '1';
        } else if (this.auditSummaryOutputDto.actionType == 'ACT') {
          this.auditorBenchAuditDetailDTO.actSelected = true;

          this.auditorBenchAuditDetailDTO.act = '1';
          this.commonDTO.act = '1';
        }
      }
      this.auditorBenchAuditDetailDTO.isWorkflowRequired = this.auditProgramMstObj.isWorkflowRequired;
      this.commonDTO.auditProgramId = this.auditSummaryOutputDto.auditId;
      this.commonDTO.departmentId = '0';
      this.commonDTO.subMenuId = '21'; //screen id for Auditor Bench
      //  this.getAuditProgramScopeStatusNList();
    } else {
      this.commonDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
      this.commonDTO.departmentId = '0';
      this.commonDTO.subMenuId = '21'; //screen id for Auditor Bench
      this.auditorBenchAuditDetailDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
      this.auditorBenchAuditDetailDTO.auditProgramStatus = this.auditProgramMstObj.statusId;
      this.auditorBenchAuditDetailDTO.auditProgramStage = this.auditProgramMstObj.cdAuditStage;
      this.auditorBenchAuditDetailDTO.pendingSelected = true;
      this.auditorBenchAuditDetailDTO.pending = '1';
      this.commonDTO.pending = '1';
      this.auditorBenchAuditDetailDTO.isWorkflowRequired = this.auditProgramMstObj.isWorkflowRequired;
      this.commonDTO.siteId = this.auditProgramMstObj.siteId;
      this.auditProgramId = this.auditProgramMstObj.auditProgramId;

      if (this.auditProgramMstObj.isWorkflowRequired == '1') {
        this.isWorkflowRequired = true;
      }
      if (this.auditProgramMstObj.isDraftReportReleased == '1') {
        this.isDraftReportReleased = true;
      }
      if (this.auditProgramMstObj.isNcFinalized == '1') {
        this.isNcFinalized = true;
      }
      if (this.auditProgramMstObj.isFinalReportReleased == '1') {
        this.isFinalReportReleased = true;
      }
      if (this.auditProgramMstObj.isMcReleased == '1') {
        this.isMcReleased = true;
      }

      this.cdAuditStatus = this.auditProgramMstObj.cdAuditStatus;
      this.cdAuditStage = this.auditProgramMstObj.cdAuditStage;
      this.cdAuditeeStage = this.auditProgramMstObj.cdAuditeeStage;
      // this.getAuditProgramScopeStatusNList();
    }
  }

  /* ngAfterViewInit() {
      this.getRatingListByClientId();
     this.getUmbrellaGroupByClientIdSiteId();
     this.getReasonListByClientId();
     this.getPdcaStatusList();
   } */

  onCollapse() { }

  getSelectedPDCAStatus(index, ratingId) {
    const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
    if (ratingId == AdmCodesDetails.PDCA_STATUS_IMPROVEMENT_DONE_100) {
      control.get('isDisableReturnBtn').setValue(true);
    } else {
      control.get('isDisableReturnBtn').setValue(false);
    }
  }

  suppDocCountEmitEvt(evt) {
    const control = <FormArray>this.dataForm.get('detailList')['controls'][this.selectedScopeIndex];
    control.get('attachmentCount').setValue(evt);
  }

  toggleSidenav() {
    this.isShow = this.isShow ? false : true;
  }

  /* getReasonListByClientId() {
     this.commonService.getReasonListByClientId(this.commonDTO)
       .subscribe(data => {
         this.reasonDropdownList = JSON.parse(JSON.stringify(data));
       }
         , (error) => {
           this.sidebarComponent.showHideLoader(false);
           this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
         }
       );
   } */

  /* getRatingListByClientId() {
     this.commonService.getRatingListByClientId(this.commonDTO)
       .subscribe(data => {
         this.ratingDropdownList = JSON.parse(JSON.stringify(data));
       }
         , (error) => {
           this.sidebarComponent.showHideLoader(false);
           this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
         }
       );
   }*/

  /*
 getPdcaStatusList() {
   this.commonService.getPdcaStatusList(this.commonDTO)
     .subscribe(data => {
       this.pdcaDropdownListCopy = JSON.parse(JSON.stringify(data));

       for (let i = 0; i < this.pdcaDropdownListCopy.length; i++) {
         if (this.pdcaDropdownListCopy[i].value.toUpperCase().includes('75')) {
           this.pdcaDropdownList.push(this.pdcaDropdownListCopy[i]);
         }
         if (this.pdcaDropdownListCopy[i].value.toUpperCase().includes('100')) {
           this.pdcaDropdownList.push(this.pdcaDropdownListCopy[i]);
         }
       }
     }
       , (error) => {
         this.sidebarComponent.showHideLoader(false);
         this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
       }
     );
 }
 */

  getAuditProgramDetailByAuditId() {
    this.commonService.getAuditProgramDetailByAuditId(this.commonDTO).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.auditProgramMstObj = this.parsedJson;
        if (this.auditProgramMstObj.cdAuditStage > '299') {
          //this.auditProgramDto.isDraftReportReleased =  1;
        } else {
          //this.auditProgramDto.isDraftReportReleased = 0;
        }
        this.getAuditProgramScopeAttachmentData();
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  /*
    getButtonList() {
      this.commonService.getButtonRoleMapList(this.commonDTO)
        .subscribe(data => {
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.buttonRoleMapResponse = this.parsedJson.resultList;
  
          this.enableShowAllRecordsDepartmentWise = this.buttonRoleMapResponse[0].enableShowAllRecord;
          this.enableAllTransactionDepartmentWise = this.buttonRoleMapResponse[0].enableAllTransaction;
          for (let i = 0; i < this.buttonRoleMapResponse.length; i++) {
  
            if (this.buttonRoleMapResponse[i].functionId == '9' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.addScopeBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '31' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.addSubScopeBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '28' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.attachmentBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '1' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.saveBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '18' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.submitBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '25' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.submitBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '26' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.returnBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '27' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.approveBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '29' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.postCommentBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '30' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.pendingItemsBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '32') {
              this.downloadAllFilesBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '33') {
              this.exportToExcel = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '34') {
              this.auditProgramLog = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '35' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.manageAuditorBtn = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '36' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.closeNonNc = true;
            }
            else if (this.buttonRoleMapResponse[i].functionId == '38' && this.buttonRoleMapResponse[i].enableAllTransaction == '1') {
              this.ncFinalize = true;
            }
          }
        }, (error) => {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
  
        });
    }
    */
  /*
    getUmbrellaGroupByClientIdSiteId() {
      this.commonService.getUmbrellaGroupByClientIdSiteId(this.commonDTO).subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.umbrellaGroupList = this.parsedJson;
  
        this.umbrellaGroupList.forEach(data => {
          if (data.groupId == '5' && data.umbrellaGroupSettingValue == '1') {
            this.captureImpactAnalysis = true;
          }
          if (data.groupId == '6' && data.umbrellaGroupSettingValue == '1') {
            this.enableNcWorkflowForAuditors = true;
          }
          if (data.groupId == '8' && data.umbrellaGroupSettingValue == '1') {
            this.enableDraftReleaseWorkflow = true;
          }
          if (data.groupId == '10' && data.umbrellaGroupSettingValue == '1') {
            this.enableAddJoinderRemarks = true;
          }
          if (data.groupId == '11' && data.umbrellaGroupSettingValue == '1') {
            this.enableAddRcoTeamComments = true;
          }
          if (data.groupId == '12') {
  
          }
          if (data.groupId == '12' && data.umbrellaGroupSettingValue == '1') {
            this.allowNcModificationBeforeDraftReportRelease = true;
          }
          if (data.groupId == '13' && data.umbrellaGroupSettingValue == '1') {
            this.allowNcReturnBeforeDraftReportRelease = true;
          }
        });
      }, (error) => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });
    }
  */

  //Comented on 30-09-2021
  /*
    getAuditProgramScopeStatusNList() {
      this.dataForm = new FormGroup({
        detailList: new FormArray([])
      });
      this.isDisplayDownloadButton = false;
      this.commonDTO.auditProgramId = this.auditProgramId;
      this.commonDTO.departmentId = this.selectedDepartmentId;
      this.sidebarComponent.showHideLoader(true);
  
      this.auditDetailsService.getAuditProgramScopeStatusNList(this.auditorBenchAuditDetailDTO)
        .subscribe(data => {
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.auditorBenchAuditDetailResponseDTO = this.parsedJson;
          this.auditDetailCheckboxCount = this.auditorBenchAuditDetailResponseDTO.auditDetailCheckboxCount;
          this.auditProgramDepartmentSectionList = this.auditorBenchAuditDetailResponseDTO.departmentSectionList;
          this.auditorBenchAuditDetailScopeList = this.auditorBenchAuditDetailResponseDTO.auditorBenchAuditDetailScopeList;
          if (this.auditorBenchAuditDetailScopeList.length > 0 && this.auditorBenchAuditDetailScopeList[0].isNcFinalized == '1') {
            this.isNcFinalized = true;
          }
          else if (this.auditorBenchAuditDetailScopeList.length > 0 && (this.auditorBenchAuditDetailScopeList[0].isNcFinalized == '0' || this.auditorBenchAuditDetailScopeList[0].isNcFinalized == null || this.auditorBenchAuditDetailScopeList[0].isNcFinalized == undefined)) {
            this.isNcFinalized = false;
          }
          if (this.auditorBenchAuditDetailScopeList.length == 0) {
            let emptyList = true;
            if (this.auditProgramDepartmentSectionList.length == 0) {
            } else {
              let isRecordFound = 0;
              for (let i = 0; i < this.auditProgramDepartmentSectionList.length; i++) {
                if (isRecordFound == 1)
                  break;
  
                if (this.auditProgramDepartmentSectionList[i].scopeCount > 0) {
                  emptyList = false;
                  for (let j = 0; j < this.auditProgramDepartmentSectionList[i].sectionList.length; j++) {
                    if (this.auditProgramDepartmentSectionList[i].sectionList[j].scopeItemsCount != null && Number(this.auditProgramDepartmentSectionList[i].sectionList[j].scopeItemsCount) > 0) {
                      isRecordFound = 1;
                      break;
                    }
                  }
                }
              }
  
              if (emptyList) {
                if (this.auditProgramDepartmentSectionList.length > 0) {
                  this.commonDTO.departmentId = this.auditProgramDepartmentSectionList[0].sectionList[0].departmentId;
                  this.getButtonList();
                }
  
              }
            }
            this.sidebarComponent.showHideLoader(false);
          } else {
            this.isDisplayDownloadButton = true;
            this.addItem(this.auditorBenchAuditDetailScopeList);
            this.isScopeAllChecked = false;
  
            if (this.auditorBenchAuditDetailDTO.departmentId == undefined
              || this.auditorBenchAuditDetailDTO.departmentId == '0'
              || this.auditorBenchAuditDetailDTO.departmentId == '') {
              let isRecordFound = 0;
              for (let i = 0; i < this.auditProgramDepartmentSectionList.length; i++) {
  
  
                if (this.auditProgramDepartmentSectionList[i].scopeCount > 0) {
                  for (let j = 0; j < this.auditProgramDepartmentSectionList[i].sectionList.length; j++) {
                    if (this.auditProgramDepartmentSectionList[i].sectionList[j].scopeItemsCount != null && Number(this.auditProgramDepartmentSectionList[i].sectionList[j].scopeItemsCount) > 0 && (this.auditProgramDepartmentSectionList[i].sectionList[j].onLoadCurrentFlag == '1')) {
  
                      this.selectedDepartmentId = this.auditProgramDepartmentSectionList[i].sectionList[j].departmentId;
                      this.commonDTO.departmentId = this.selectedDepartmentId;
                      this.selectedDepartementName = this.auditProgramDepartmentSectionList[i].sectionList[j].departmentName;
                      this.selectedSectionName = this.auditProgramDepartmentSectionList[i].sectionList[j].sectionName;
                      this.selectedSectionId = this.auditProgramDepartmentSectionList[i].sectionList[j].sectionId;
  
                      isRecordFound = 1;
                      if (isRecordFound == 1) {
                        this.getButtonList();
                        break;
                      }
                      break;
                    }
                  }
                }
              }
  
            } else {
              this.getButtonList();
            }
  
            this.sidebarComponent.showHideLoader(false);
          }
        }, (error) => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        });
    }
    */

  onChangeOfSection(section) {
    //Commented on 24-09-2021
    /*
    this.auditorBenchAuditDetailDTO.departmentId = section.departmentId;
    this.auditorBenchAuditDetailDTO.sectionId = section.sectionId;
    this.commonDTO.sectionId = this.auditorBenchAuditDetailDTO.sectionId;
    this.selectedDepartmentId = section.departmentId;
    this.selectedSectionId = section.sectionId;
    this.selectedDepartementName = section.departmentName;
    this.selectedSectionName = section.sectionName;
    this.getAuditProgramScopeStatusNList();
    */
    sessionStorage.setItem('index', '');
    this.step = '';
    this.commonDTO.departmentId = section.departmentId;
    this.commonDTO.sectionId = section.sectionId;
    this.getAuditProgramScopeAttachmentData();
  }

  addItem(dataList: any): void {
    this.detailList = this.dataForm.get('detailList') as FormArray;
    dataList.forEach(data => {
      this.detailList.push(this.createItem(data));
    });
  }

  createItem(data): FormGroup {
    return this.fb.group({
      // Scope Row
      auditProgramId: new FormControl(data.scopeId),
      scopeId: new FormControl(data.scopeId),
      sectionCode: new FormControl(data.sectionCode),
      scopeDescription: new FormControl(data.scopeDescription),

      // importantTips: new FormControl(data.importantTips),
      // orderId: new FormControl(data.orderId),
      departmentId: new FormControl(data.departmentId),
      sectionId: new FormControl(data.sectionId),
      isWorkflowRequired: new FormControl(data.isWorkflowRequired),
      isPostCommentPosted: new FormControl(data.isPostCommentPosted),
      auditNcFinalizedBy: new FormControl(data.auditNcFinalizedBy),
      isDraftReportReleased: new FormControl(data.isDraftReportReleased),
      isMcReleased: new FormControl(data.isMcReleased),
      isFinalReportReleased: new FormControl(data.isFinalReportReleased),
      isPostCommentExists: new FormControl(data.isPostCommentExists),
      statusId: new FormControl(data.statusId),
      cdScopeItemStatus: new FormControl(data.cdScopeItemStatus),
      postCommentCount: new FormControl(data.postCommentCount),
      attachmentCount: new FormControl(data.attachmentCount),
      pendingItemCount: new FormControl(data.pendingItemCount),
      auditorNcWfReqId: new FormControl(data.auditorNcWfReqId),
      auditorNcWfReqStatusId: new FormControl(data.auditorNcWfReqStatusId),
      isAttachmentExists: new FormControl(data.isAttachmentExists),
      subObservationParentId: new FormControl(data.subObservationParentId),
      isPersistenceNc: new FormControl(data.isPersistenceNc),
      cdPdcaStatus: new FormControl(data.cdPdcaStatus),
      cdPdcaStatusUpdated: new FormControl(data.cdPdcaStatus),
      cdReturnStatus: new FormControl(data.cdReturnStatus),
      expanded: new FormControl(false),
      cssClass: new FormControl(data.cssClass),
      fullScreenClass: new FormControl(''),
      fullScreenClassTooltip: new FormControl('Fullscreen View'),

      // Scope Detail
      /* wfDeptId: new FormControl(''),
       ratingMstId: new FormControl(''),
       sectionOrder: new FormControl(''),
         executiveSummary: new ValueDirtyFormControl('', {
           equals: (orig, curr) => `${orig}` === `${curr}`
         }),
         auditorObservation: new ValueDirtyFormControl('', {
           equals: (orig, curr) => `${orig}` === `${curr}`
         }),
         recommendation: new FormControl(''),
         impactComments: new FormControl(''),
         joinderRemarks: new FormControl(''),
         rcoComments: new FormControl(''),
         cdReasonId: new FormControl(''),
         managementResponse: new FormControl(''),
         auditeeWfReqId: new FormControl(''),
         auditeeWfReqStatusId: new FormControl(data.auditeeWfReqStatusId),
         auditeePncWfReqId: new FormControl(''),
         auditeePncWfReqStatusId: new FormControl(data.auditeePncWfReqStatusId),
   
         auditeeTargetDate: new FormControl(''),
         auditeeRevisedTargetDate: new FormControl(''),
         persistenceManagementResponse: new FormControl(''),
         auditorPersistenceComment: new FormControl(''),
         auditorReturnRemarks: new FormControl(''),
         auditorComment: new FormControl(''),
         postedCmnt: new FormControl(''),
         isPostComment: new FormControl(''),
         remarks: new FormControl(''),
         entBy: new FormControl(''),
         entStamp: new FormControl(''),
         updBy: new FormControl(''),
         updStamp: new FormControl(''), */

      disabledInputArea: new FormControl(false),

      reasonDisabled: new FormControl(false),
      ratingDisabled: new FormControl(false),
      isDisableReturnBtn: new FormControl(false),

      readOnly: new FormControl(this.isDraftReportReleased),
      pdcaStatus: new FormControl(''),
      auditorObservationApplicable: new ValueDirtyFormControl('Yes'),
      isExpanded: new FormControl(false),
      checkedItem: new ValueDirtyFormControl(false, {
        equals: (orig, curr) => `${orig}` === `${curr}`,
      }),
    });
  }

  //For Auditor Scope Detail for Fullscreenview
  getAuditProgramScopeDetail(index, scopeId, isExpandChange) {
    /*
    this.selectedScopeIndex = index;
    const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
    this.sidebarComponent.showHideLoader(true);
    this.auditorBenchAuditDetailDTO.scopeId = scopeId;
    //auditProgramId and documentRepositoryType set on 27-09-2021, documentRepositoryType == Auditor or Auditee
    this.auditorBenchAuditDetailDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
    this.auditorBenchAuditDetailDTO.scopePrivilege = this.documentRepositoryType;
    //End

    this.auditDetailsService.getAuditProgramScopeDetail(this.auditorBenchAuditDetailDTO)
      .subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.auditorBenchAuditDetailScopeDetailList = this.parsedJson;
        this.auditorBenchAuditDetailScopeDetailDTO = this.auditorBenchAuditDetailScopeDetailList[0];
        this.sidebarComponent.showHideLoader(false);
        const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
        //OPEN AUDITEE SIDE
        if (control.get('cssClass').value == 'nc-scope' || control.get('cssClass').value == 'pnc-scope') {
          this.openAuditeeSide = true;
        }
        else {
          this.openAuditeeSide = false;
        }
        //OPEN RCO_REJOINDER SIDE
        this.openRcoRejoinderSide =
          (!this.isWorkflowRequired || (this.isWorkflowRequired && control.get('auditeeWfReqStatusId').value == '6'))
          && (this.isMcReleased)
          && control.get('cdPdcaStatus').value != null
          && control.get('cdPdcaStatus').value != '20'
          && control.get('cdPdcaStatus').value != '33'
          && (control.get('cdReturnStatus').value == null || (control.get('cdReturnStatus').value != '230'
            && control.get('cdReturnStatus').value != '231'));
        //OPEN AUDITEE SIDE NC SCOPE 
        if ((control.get('cssClass').value == 'nc-scope')
          && (this.isMcReleased || this.allowNcModificationBeforeDraftReportRelease)) {
          this.openNcScopeSide = true;
        }
        else {
          this.openNcScopeSide = false;
        }
        // OPEN AUDITEE SIDE PNC SCOPE
        if ((control.get('cssClass').value == 'pnc-scope')
          && (this.isMcReleased || this.allowNcModificationBeforeDraftReportRelease)) {
          this.openPncScopeSide = true;
        }
        else {
          this.openPncScopeSide = false;
        }
        //OPEN PDCA SIDE
        if (((!this.isWorkflowRequired
          || (this.isWorkflowRequired && control.get('auditeeWfReqStatusId').value == '6'))
          && (this.isMcReleased || this.allowNcModificationBeforeDraftReportRelease)
          && control.get('cdPdcaStatus').value != null
          && control.get('cdPdcaStatus').value != '20'
          && control.get('cdPdcaStatus').value != '33'
          && (control.get('cdReturnStatus').value == null
            || (control.get('cdReturnStatus').value != '230'
              && control.get('cdReturnStatus').value != '231'))
          && !(control.get('statusId').value == '40'
            && this.isNcFinalized))) {
          this.openPdcaSide = true;
        }
        else {
          this.openPdcaSide = false;

        }

        //OPEN PNC PDCA SIDE
        if ((!this.isWorkflowRequired
          || (this.isWorkflowRequired &&
            (
              (control.get('auditeeWfReqStatusId').value == '6'
                || control.get('auditeeWfReqStatusId').value == null
              )
              &&
              (
                control.get('auditeePncWfReqStatusId').value == '6'
                || control.get('auditeePncWfReqStatusId').value == null
              )
            )))
          && (this.isMcReleased || this.allowNcModificationBeforeDraftReportRelease)
          && control.get('cdPdcaStatus').value != null
          && control.get('cdPdcaStatus').value != '20'
          && control.get('cdPdcaStatus').value != '33'
          && control.get('cdPdcaStatus').value != '23'
          && (
            control.get('cdReturnStatus').value == null
            || (control.get('cdReturnStatus').value != '230'
              && control.get('cdReturnStatus').value != '231')
          )
          && !(control.get('statusId').value == '40'
            && this.isNcFinalized)) {
          this.openPncPdcaSide = true;
        } else {
          this.openPncPdcaSide = false;
        }

        //OPEN RETURN BTN SIDE
        if (control.get('cdReturnStatus').value == null
          || (control.get('cdReturnStatus').value != '230'
            && control.get('cdReturnStatus').value != '231')) {
          this.openAuditorReturnBtnSide = true;
        }
        else {
          this.openAuditorReturnBtnSide = false;
        }

        //OPEN SAVE_SUBMIT BTN SIDE
        if ((control.get('cssClass').value == 'pending'
          || control.get('cssClass').value == 'nc-scope'
          || control.get('cssClass').value == 'closed'
          || control.get('cssClass').value == 'na-scope'
        ) && !this.isDraftReportReleased
          && !(control.get('statusId').value == '40'
            && this.isNcFinalized)) {
          this.openSaveSubmitBtnSide = true;
        }
        else {
          this.openSaveSubmitBtnSide = false;
        }

        if (control.get('cssClass').value == 'nc-scope' && this.isNcFinalized && (control.get('statusId').value == '40' || (control.get('auditeeWfReqStatusId').value == '3' && this.isWorkflowRequired))) {
          this.draftAtAuditeeSideNote = true;
        }
        else {
          this.draftAtAuditeeSideNote = false;
        }
        if (control.get('cssClass').value == 'pnc-scope' && (control.get('statusId').value == '40' || (control.get('auditeePncWfReqStatusId').value == '3' && this.isWorkflowRequired))) {
          this.draftAtAuditeeSidePncNote = true;
        }
        else {
          this.draftAtAuditeeSidePncNote = false;
        }
        control.get('wfDeptId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.wfDeptId)
        control.get('ratingMstId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.ratingMstId)
        control.get('sectionOrder').setValue(this.auditorBenchAuditDetailScopeDetailDTO.sectionOrder)
        control.get('executiveSummary').setValue(this.auditorBenchAuditDetailScopeDetailDTO.executiveSummary)
        control.get('auditorObservation').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorObservation)
        control.get('recommendation').setValue(this.auditorBenchAuditDetailScopeDetailDTO.recommendation)

        if (this.auditorBenchAuditDetailScopeDetailDTO.isObservationApplicable == '1') {
          control.get('auditorObservationApplicable').setValue('Yes')
        } else if (this.auditorBenchAuditDetailScopeDetailDTO.cdScopeItemStatus == '9') {
          control.get('auditorObservationApplicable').setValue('Yes')
        } else {
          control.get('auditorObservationApplicable').setValue('No')
          control.get('cdReasonId').setValue('');
          control.get('reasonDisabled').setValue(true);
          control.get('ratingMstId').setValue('');
          this.disabledIncludeInReport = true;
        }
        control.get('impactComments').setValue(this.auditorBenchAuditDetailScopeDetailDTO.impactComments)
        control.get('joinderRemarks').setValue(this.auditorBenchAuditDetailScopeDetailDTO.joinderRemarks)
        control.get('rcoComments').setValue(this.auditorBenchAuditDetailScopeDetailDTO.rcoComments)
        control.get('cdReasonId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.cdReasonId)
        control.get('managementResponse').setValue(this.auditorBenchAuditDetailScopeDetailDTO.managementResponse)
        control.get('auditeeWfReqId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeeWfReqId)
        control.get('auditeeWfReqStatusId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeeWfReqStatusId)
        control.get('ratingMstId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.ratingMstId);
        control.get('auditeePncWfReqId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeePncWfReqId)
        control.get('auditeePncWfReqStatusId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeePncWfReqStatusId)
        var auditeeTargetDateStr = "";
        if (this.auditorBenchAuditDetailScopeDetailDTO.auditeeTargetDate != null
          && this.auditorBenchAuditDetailScopeDetailDTO.auditeeTargetDate != '') {
          auditeeTargetDateStr = this.datePipe.transform(new Date(this.auditorBenchAuditDetailScopeDetailDTO.auditeeTargetDate), "dd-MMM-yyyy");
          control.get('auditeeTargetDate').setValue(auditeeTargetDateStr)
        } else {
          control.get('auditeeTargetDate').setValue(auditeeTargetDateStr)
        }
        var auditeeRevisedTargetDateStr = "";
        if (this.auditorBenchAuditDetailScopeDetailDTO.auditeeRevisedTargetDate != null
          && this.auditorBenchAuditDetailScopeDetailDTO.auditeeRevisedTargetDate != '') {
          auditeeRevisedTargetDateStr = this.datePipe.transform(new Date(this.auditorBenchAuditDetailScopeDetailDTO.auditeeRevisedTargetDate), "dd-MMM-yyyy");
          control.get('auditeeRevisedTargetDate').setValue(auditeeRevisedTargetDateStr)
        } else {
          control.get('auditeeRevisedTargetDate').setValue(auditeeRevisedTargetDateStr)
        }
        control.get('persistenceManagementResponse').setValue(this.auditorBenchAuditDetailScopeDetailDTO.persistenceManagementResponse)
        control.get('auditorComment').setValue(this.auditorBenchAuditDetailScopeDetailDTO.remarks);
        control.get('auditorPersistenceComment').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorPersistenceComment)
        control.get('auditorReturnRemarks').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorReturnRemarks)
        control.get('postedCmnt').setValue(this.auditorBenchAuditDetailScopeDetailDTO.postedCmnt)
        control.get('isPostComment').setValue(this.auditorBenchAuditDetailScopeDetailDTO.isPostComment)
        control.get('entBy').setValue(this.auditorBenchAuditDetailScopeDetailDTO.entBy)
        control.get('entStamp').setValue(this.auditorBenchAuditDetailScopeDetailDTO.entStamp)
        control.get('updBy').setValue(this.auditorBenchAuditDetailScopeDetailDTO.updBy)
        control.get('updStamp').setValue(this.auditorBenchAuditDetailScopeDetailDTO.updStamp)
        control.get('ratingMstId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.ratingMstId);
        control.get('attachmentCount').setValue(this.auditorBenchAuditDetailScopeDetailDTO.attachmentCount)
        control.get('postCommentCount').setValue(this.auditorBenchAuditDetailScopeDetailDTO.postCommentCount)
        control.get('auditorNcWfReqId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorNcWfReqId)
        control.get('auditorNcWfReqStatusId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorNcWfReqStatusId)
        control.get('pdcaStatus').setValue(this.auditorBenchAuditDetailScopeDetailDTO.pdcaStatus)
        control.get('checkedItem').setValue(false);

        if (isExpandChange) {
          control.get('isExpanded').setValue(true);
        }
        if (this.auditorBenchAuditDetailScopeDetailDTO.isPncRecall == '1') {
          this.returnBtn = false;
          this.approveBtn = false;
        }
        else {
          this.returnBtn = true;
          this.approveBtn = true;
        }
        let ratingArray = this.ratingDropdownList.filter((ratingDto) => {
          if (ratingDto.ratingId == this.auditorBenchAuditDetailScopeDetailDTO.ratingMstId) {
            return ratingDto;
          }
        });
        this.checkIncludeInReport = this.auditorBenchAuditDetailScopeDetailDTO.includeInReport == '1' ? true : false;
        if (ratingArray != undefined && ratingArray.length > 0) {
          let cdIncludeInExecutiveSummary = ratingArray[0].cdIncludeInExecutiveSummary;
          if (cdIncludeInExecutiveSummary == AdmCodesDetails.CD_INCLUDE_IN_EXECUTIVE_SUMMARY_NO + '') {
            this.checkIncludeInReport = false;
            this.disabledIncludeInReport = true;
            this.ch.writeValue(false);
          } else if (cdIncludeInExecutiveSummary == AdmCodesDetails.CD_INCLUDE_IN_EXECUTIVE_SUMMARY_YES + '') {
            this.checkIncludeInReport = true;
            this.disabledIncludeInReport = true;
            this.ch.writeValue(true);

          } else if (cdIncludeInExecutiveSummary == null || cdIncludeInExecutiveSummary == AdmCodesDetails.CD_INCLUDE_IN_EXECUTIVE_SUMMARY_OPTIONAL + '') {

            this.disabledIncludeInReport = false;
          }
        }

        if (this.checkIncludeInReport == true) {
          this.ch.writeValue(true);
        }

        this.dataForm.markAsPristine(); this.dataForm.markAsUntouched();

      }, (error) => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        this.sidebarComponent.showHideLoader(false);
      });
    if (isExpandChange) {
      control.get('isExpanded').setValue(true);
    }
    this.dataForm.markAsPristine(); this.dataForm.markAsUntouched();
    */
  }
  //End

  // For Auditee Scope Detail for Fullscreen View
  getAuditProgramScopeDetailAuditee(index, scopeId) {
    /*
    this.selectedScopeIndex = index;
    const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
    this.sidebarComponent.showHideLoader(true);
    this.auditorBenchAuditDetailDTO.actionType = "IL";
    //this.auditeeDetailDTO.scopeId = control.get('scopeId').value;
    this.auditorBenchAuditDetailDTO.scopeId = scopeId;
    this.auditeeDetailsService.getAuditProgramScopeDetail(this.auditorBenchAuditDetailDTO)
      .subscribe(data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.auditorBenchAuditDetailScopeDetailList = this.parsedJson;
        this.auditorBenchAuditDetailScopeDetailDTO = this.auditorBenchAuditDetailScopeDetailList[0];
        this.sidebarComponent.showHideLoader(false);
        const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
       
        control.get('isExpanded').setValue(true);
        control.get('wfDeptId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.wfDeptId)
        control.get('ratingMstId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.ratingMstId)
        control.get('executiveSummary').setValue(this.auditorBenchAuditDetailScopeDetailDTO.executiveSummary)
        control.get('auditorObservation').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorObservation)
        control.get('recommendation').setValue(this.auditorBenchAuditDetailScopeDetailDTO.recommendation)

        control.get('impactComments').setValue(this.auditorBenchAuditDetailScopeDetailDTO.impactComments)
        control.get('joinderRemarks').setValue(this.auditorBenchAuditDetailScopeDetailDTO.joinderRemarks)
        control.get('rcoComments').setValue(this.auditorBenchAuditDetailScopeDetailDTO.rcoComments)
        control.get('cdReasonId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.cdReasonId)
        control.get('managementResponse').setValue(this.auditorBenchAuditDetailScopeDetailDTO.managementResponse)
        control.get('auditeeWfReqId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeeWfReqId)
        control.get('auditeeWfReqStatusId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeeWfReqStatusId)
        control.get('auditeePncWfReqId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeePncWfReqId)
        control.get('auditeePncWfReqStatusId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditeePncWfReqStatusId)

        if (this.auditorBenchAuditDetailScopeDetailDTO.auditeeTargetDate != '' && this.auditorBenchAuditDetailScopeDetailDTO.auditeeTargetDate != null && this.auditorBenchAuditDetailScopeDetailDTO.auditeeTargetDate != undefined) {
          let validDate = moment(this.auditorBenchAuditDetailScopeDetailDTO.auditeeTargetDate).format('YYYY-MM-DD');
          control.get('auditeeTargetDate').setValue(validDate);
        }
        else {
          control.get('auditeeTargetDate').setValue('');
        }
        
        if (this.auditorBenchAuditDetailScopeDetailDTO.auditeeRevisedTargetDate != '' && this.auditorBenchAuditDetailScopeDetailDTO.auditeeRevisedTargetDate != null && this.auditorBenchAuditDetailScopeDetailDTO.auditeeRevisedTargetDate != undefined) {
          let validRevisedDate = moment(this.auditorBenchAuditDetailScopeDetailDTO.auditeeRevisedTargetDate).format('YYYY-MM-DD');
          control.get('auditeeRevisedTargetDate').setValue(validRevisedDate);
        }
        else {
          control.get('auditeeRevisedTargetDate').setValue('');
        }
        control.get('persistenceManagementResponse').setValue(this.auditorBenchAuditDetailScopeDetailDTO.persistenceManagementResponse)
        control.get('auditorPersistenceComment').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorPersistenceComment)
        control.get('auditorReturnRemarks').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorReturnRemarks)
        control.get('postedCmnt').setValue(this.auditorBenchAuditDetailScopeDetailDTO.postedCmnt)
        control.get('isPostComment').setValue(this.auditorBenchAuditDetailScopeDetailDTO.isPostComment)
        control.get('entBy').setValue(this.auditorBenchAuditDetailScopeDetailDTO.entBy)
        control.get('entStamp').setValue(this.auditorBenchAuditDetailScopeDetailDTO.entStamp)
        control.get('updBy').setValue(this.auditorBenchAuditDetailScopeDetailDTO.updBy)
        control.get('updStamp').setValue(this.auditorBenchAuditDetailScopeDetailDTO.updStamp)

        control.get('attachmentCount').setValue(this.auditorBenchAuditDetailScopeDetailDTO.attachmentCount)
        control.get('postCommentCount').setValue(this.auditorBenchAuditDetailScopeDetailDTO.postCommentCount)
        control.get('auditorNcWfReqId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorNcWfReqId)
        control.get('auditorNcWfReqStatusId').setValue(this.auditorBenchAuditDetailScopeDetailDTO.auditorNcWfReqStatusId)
        control.get('pdcaStatus').setValue(this.auditorBenchAuditDetailScopeDetailDTO.pdcaStatus)
        control.get('cdPdcaStatus').setValue(this.auditorBenchAuditDetailScopeDetailDTO.cdPdcaStatus)
        control.get('checkedItem').setValue(false);

        if (this.isDraftReportReleased || control.get('cssClass').value == 'workflow' || control.get('cssClass').value == 'closed' || control.get('cssClass').value == 'na-scope') {
          control.get('disabledInputArea').setValue(true);
        }

      }, (error) => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      });
    this.dataForm.markAsPristine(); this.dataForm.markAsUntouched();
    */
  }
  //Ent

  //To download supporting documents
  downloadSuppDocument(item: { fileName: string; fileType: string; documentId: string }) {
    this.supportingDocumentDto.fileName = item.fileName;
    this.supportingDocumentDto.fileType = item.fileType;
    this.supportingDocumentDto.documentId = item.documentId;
    this.supportingDocumentDto.companyId = this.auditProgramMstObj.companyId;
    this.supportingDocumentDto.buId = this.auditProgramMstObj.siteId;
    this.sidebarComponent.showHideLoader(true);
    this.suppDocService.downloadSupportingDoc(this.supportingDocumentDto).subscribe(
      data => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = item.fileName;
        link.click();
        this.sidebarComponent.showHideLoader(false);
      },
      error => {
        if (error.error.msgId == undefined || error.error.msgId == '') {
          error.error.msgId = 'cams.label.common.file.not.found'; //'cams.label.common.errorOccuredInOperation';
          this.customMessage.showErrorMessage(error.error.msgId, '');
        } else {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      }
    );
  }
  //End

  // To delete supporint document
  deleteSupportingDocument(item: any, index: number) {
    this.deleteItem = item;
    let obj = this;
    obj.dialog.confirm(
      obj.ts.transform('cams.label.common.confirm'),
      obj.ts.transform('cams.label.attachmentList.confirmationToDeleteSupportingDocument'),
      async function () {
        obj.deleteSupportingDoc(index);
        //dialogRef.disableClose = true;
      },
      function () {
        //ACTION: Do this if user says NO
        //that.name = "No clicked";
      }
    );
  }

  deleteSupportingDoc(index: number) {
    this.supportingDocumentValue = this.deleteItem;
    this.supportingDocumentValue.companyId = this.auditProgramMstObj.companyId;
    this.supportingDocumentValue.buId = this.auditProgramMstObj.siteId;
    this.supportingDocumentValue.auditScopeId = this.supportingDocumentList[index].auditScopeId;
    this.supportingDocumentDto.documentId = this.deleteItem.documentId;
    this.supportingDocumentValue.totalSize = this.supportingDocumentList.length;
    if (parseInt(this.auditItemDetails.isFinalReportReleased) == 1) {
      this.customMessage.showErrorMessage(
        'cams.label.attachmentList.cannotDeleteAlreadyReleasedFinalReport',
        ''
      );
      return false;
    }
    this.sidebarComponent.showHideLoader(true);
    this.suppDocService.deleteSupportingDocument(this.supportingDocumentValue).subscribe(
      (data: any) => {
        if (data.status == 1) {
          this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
          this.refreshAttachmentCountIfSearchApplyAndDelete();
          //  this.getSupportingDocList('List');
          {
            this.getSupportingDocumentList(
              this.supportingDocumentDto.auditScopeId,
              'true',
              this.selectedScopeIndex
            );
          }
        }
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        error.error.msgId = 'cams.label.common.file.not.found';
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  //To Refresh count if search apply
  refreshAttachmentCountIfSearchApplyAndDelete() {
    if (this.attachmentNameSearch != '' && this.attachmentNameSearch != undefined) {
      sessionStorage.setItem('index', '');
      this.step = '';
      this.commonDTO.departmentId = '0';
      this.commonDTO.sectionId = '0';
      this.getAuditProgramScopeAttachmentData();
    }
  }

  attachmentItems(index, scopeId) {
    this.step = sessionStorage.getItem('index');
    this.selectedScopeIndex = index;
    this.selectedScopeId = scopeId;
    this.attachedScope(index, scopeId);
  }

  attachedScope(index, scopeId) {
    const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
    this.auditItemDetails.companyId = this.auditProgramMstObj.companyId;
    this.auditItemDetails.buId = this.auditProgramMstObj.siteId;
    this.auditItemDetails.auditProgramId = this.auditProgramMstObj.auditProgramId;
    if (this.auditProgramMstObj.cdAuditStage > '302') {
      this.auditItemDetails.isFinalReportReleased = '1';
    } else {
      this.auditItemDetails.isFinalReportReleased = '0';
    }
    this.auditItemDetails.isScopeItemNC = '0';
    this.auditItemDetails.auditScopeId = scopeId;
    this.auditItemDetails.departmentId = this.selectedDepartmentId;
    this.auditItemDetails.deptName = this.selectedDepartementName;
    this.auditItemDetails.sectionName = this.selectedSectionName;
    this.auditItemDetails.businessProcessDescription = control.get('scopeDescription').value;
    this.auditItemDetails.sectionCode = control.get('sectionCode').value;
    this.auditItemDetails.pdcaStatus = control.get('cdPdcaStatus').value;
    this.openSuppDocPage = true;
    this.openedattachments = !this.openedattachments;
  }

  closedlist(evt: boolean) {
    this.openedattachments = evt;
    this.openSuppDocPage = evt;
    const control = <FormArray>this.dataForm.get('detailList')['controls'][this.selectedScopeIndex];

    if (this.attachmentNameSearch != '' && this.attachmentNameSearch != undefined) {
      const control = <FormArray>(
        this.dataForm.get('detailList')['controls'][this.selectedScopeIndex]
      );
      if (control.get('attachmentCount').value == 0) {
        sessionStorage.setItem('index', '');
        this.step = '';
      }
      this.getAuditProgramScopeAttachmentData();
      this.getSupportingDocumentList(this.selectedScopeId, this.isTable, this.selectedScopeIndex);
    } else {
      this.getSupportingDocumentList(this.selectedScopeId, this.isTable, this.selectedScopeIndex);
    }
  }

  //Search for attachments
  search() {
    sessionStorage.setItem('index', '');
    this.step = '';
    this.commonDTO.departmentId = '0';
    this.commonDTO.sectionId = '0';

    if (this.attachmentNameSearch != '' && this.attachmentNameSearch != undefined) {
      this.commonDTO.searchValue = this.attachmentNameSearch;
      this.supportingDocumentDto.searchFileName = this.attachmentNameSearch;
    } else {
      this.commonDTO.searchValue = null;
      this.supportingDocumentDto.searchFileName = '';
    }
    this.getAuditProgramScopeAttachmentData();
  }
  //End

  getAuditProgramScopeAttachmentData() {
    this.dataForm = new FormGroup({
      detailList: new FormArray([]),
    });
    this.commonDTO.inWf = this.auditProgramMstObj.isWorkflowRequired;
    this.commonDTO.userType = this.documentRepositoryType;

    if (this.auditProgramMstObj.auditProgramId == undefined) {
      this.getAuditProgramDetailByAuditId();
    } else {
      this.commonDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
    }
    this.commonDTO.auditProgramId = this.auditProgramMstObj.auditProgramId;
    this.auditDetailsService.getAuditProgramScopeAttachmentList(this.commonDTO).subscribe(data => {
      this.parsedJson = JSON.parse(JSON.stringify(data));
      this.auditorBenchAuditDetailResponseDTO = this.parsedJson;
      this.auditProgramDepartmentSectionList = this.auditorBenchAuditDetailResponseDTO.departmentSectionList;
      this.auditorBenchAuditDetailScopeList = this.auditorBenchAuditDetailResponseDTO.auditorBenchAuditDetailScopeList;
      if (
        this.auditorBenchAuditDetailDTO.departmentId == undefined ||
        this.auditorBenchAuditDetailDTO.departmentId == '0' ||
        this.auditorBenchAuditDetailDTO.departmentId == ''
      ) {
        for (let i = 0; i < this.auditProgramDepartmentSectionList.length; i++) {
          if (this.auditProgramDepartmentSectionList[i].scopeCount > 0) {
            for (let j = 0; j < this.auditProgramDepartmentSectionList[i].sectionList.length; j++) {
              if (
                this.auditProgramDepartmentSectionList[i].sectionList[j].scopeItemsCount != null &&
                Number(this.auditProgramDepartmentSectionList[i].sectionList[j].scopeItemsCount) >
                0 &&
                this.auditProgramDepartmentSectionList[i].sectionList[j].onLoadCurrentFlag == '1'
              ) {
                this.selectedDepartmentId = this.auditProgramDepartmentSectionList[i].sectionList[
                  j
                ].departmentId;
                //this.commonDTO.departmentId = this.selectedDepartmentId;
                this.selectedDepartementName = this.auditProgramDepartmentSectionList[
                  i
                ].sectionList[j].departmentName;
                this.selectedSectionName = this.auditProgramDepartmentSectionList[i].sectionList[
                  j
                ].sectionName;
                this.selectedSectionId = this.auditProgramDepartmentSectionList[i].sectionList[
                  j
                ].sectionId;
                break;
              }
            }
          }
        }
      }
      // this.getButtonList();
      this.addItem(this.auditorBenchAuditDetailScopeList);
    });
  }

  //Method to get attachment list. It will execute sql query.
  getSupportingDocumentList(scopeID: string, isTable: string, index) {
    this.selectedScopeIndex = index;
    this.supportingDocumentDto.auditScopeId = scopeID;
    this.suppDocService.getSupportingDocumentList(this.supportingDocumentDto).subscribe(
      (data: any) => {
        this.supportingDocumentList = data;
        const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
        if (this.attachmentNameSearch == '' || this.attachmentNameSearch == undefined) {
          control.get('attachmentCount').setValue(this.supportingDocumentList.length);
        }
        if (control.get('attachmentCount').value == 0) {
          this.refreshDataAfterDeleteAllAtachmentOfOneScope();
        }
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
  //Ent
  //To refresh counts after delete all attachment from a Scope Item
  refreshDataAfterDeleteAllAtachmentOfOneScope() {
    if (this.commonDTO.departmentId == '0') {
      sessionStorage.setItem('index', '');
      this.step = '';
      this.commonDTO.departmentId = '0';
      this.commonDTO.sectionId = '0';
      this.getAuditProgramScopeAttachmentData();
    } else {
      sessionStorage.setItem('index', '');
      this.step = '';
      this.getAuditProgramScopeAttachmentData();
    }
  }

  //To expand only clicked scope tab and all other will close.
  setStep(index: string) {
    this.step = index;
    sessionStorage.setItem('index', index);
  }
  //End

  //Click of Fullscreen View. It is not in work now, 06-10-2021 ( )
  /*  changeTofullscreen(index, scopeId, isTable) {
     this.isTable = isTable;
     this.panelH.forEach((element, i) => {
       if (i == index) {
         const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
         if (control.get('fullScreenClass').value == '') {
           control.get('fullScreenClass').setValue('fullscreen');
           control.get('fullScreenClassTooltip').setValue('Back to Normal View');
           if (element._getExpandedState() == 'collapsed') {
             element._toggle();
           }
           control.get('isExpanded').setValue(false);
           this.onExpand(index, scopeId, isTable);
           this.dataForm.markAsPristine(); this.dataForm.markAsUntouched();
 
         } else {
           if (this.dataForm.touched && this.dataForm.dirty) {
             if (confirm(this.ts.transform("cams.label.common.confirmationToContinueUnsavedData"))) {
               control.get('fullScreenClass').setValue('');
               control.get('fullScreenClassTooltip').setValue('Fullscreen View');
               control.get('isExpanded').setValue(false);
               this.dataForm.markAsPristine(); this.dataForm.markAsUntouched();
               if (element._getExpandedState() != 'collapsed') {
                 element._toggle();
               }
             }
           } else {
             control.get('fullScreenClass').setValue('');
             control.get('fullScreenClassTooltip').setValue('Fullscreen View');
             control.get('isExpanded').setValue(false);
             if (element._getExpandedState() != 'collapsed') {
               element._toggle();
             }
           }
         }
       }
     });
   }
 
   onExpand(index, scopeId, isTable) {
     const control = <FormArray>this.dataForm.get('detailList')['controls'][index];
     if (control.get('fullScreenClass').value == 'fullscreen') {
       this.panelH.forEach((element, i) => {
         if (i == index) {
           if (element._getExpandedState() == 'collapsed') {
             element._toggle();
             element._toggle();
             control.get('fullScreenClass').setValue('');
             control.get('fullScreenClassTooltip').setValue('Fullscreen View')
           }
         }
       });
     } if (!control.get('isExpanded').value) {
       if (this.documentRepositoryType == 'Auditee' && isTable != 'false') {
         this.getAuditProgramScopeDetailAuditee(index, scopeId);
       } else if (this.documentRepositoryType == 'Auditor' && isTable != 'false') {
         this.getAuditProgramScopeDetail(index, scopeId, true);
       } else {
         this.getSupportingDocumentList(scopeId, isTable, index);
       }
       this.dataForm.markAsPristine(); this.dataForm.markAsUntouched();
     } else {
       control.get('isExpanded').setValue(false);
     }
     this.dataForm.markAsPristine(); this.dataForm.markAsUntouched();
   }  */
  //End
}
